import { Notifications } from '@mantine/notifications';
import '../../../styles/ThemedNotifications.css';

export default function ThemedNotifications() {
  return <Notifications position="top-right" zIndex={10000} />;
}
